import { useQuery } from '@tanstack/react-query';
import { useGql } from '@ah/design';
import { Header, PillTabs, PullToRefresh, type PillTab } from '@ah/design/mobile';
import { Bookmark } from 'lucide-react';
import { SAVED_EPISODES_QUERY, type EpisodeListItem } from '../shared/index.ts';
import { EpisodeRow, EpisodeListSkeleton, ErrorRetry } from './_parts.tsx';

const TABS: PillTab[] = [
  { to: '/podcasts',        label: 'For You', end: true },
  { to: '/podcasts/latest', label: 'Latest' },
  { to: '/podcasts/shows',  label: 'Shows' },
  { to: '/podcasts/seen',   label: 'Heard' },
  { to: '/podcasts/saved',  label: 'Saved' },
];

export function SavedPodcasts() {
  const gql = useGql();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['podcasts', 'saved'],
    queryFn: async () => {
      const res = await gql.request<{ savedEpisodes: EpisodeListItem[] }>(SAVED_EPISODES_QUERY, { limit: 100 });
      return res.savedEpisodes;
    },
  });

  return (
    <div className="fixed inset-0 flex flex-col bg-background">
      <Header title="Podcasts" />
      <PillTabs tabs={TABS} />
      <PullToRefresh className="flex-1 px-3 py-3" onRefresh={() => refetch()}>
        {isLoading ? (
          <EpisodeListSkeleton />
        ) : error ? (
          <ErrorRetry label="Could not load podcasts." onRetry={() => refetch()} />
        ) : !data || data.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">
            <Bookmark size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">Nothing saved yet. Tap Save on an episode to bookmark it for later.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {data.map((ep) => <EpisodeRow key={ep.id} ep={ep} />)}
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
